import { Color, Size, Spacing } from '@opallabs/gem'
import { Icon } from '@opallabs/lapidary'
import * as styles from './styles'
import type { OpalWordmarkProps } from './types'

export const OpalWordmark = ({
  includeLogo,
  prideMode,
  styleOverrides,
  theme = 'dark',
}: OpalWordmarkProps): JSX.Element => {
  if (prideMode) {
    return (
      <Icon
        ariaMode="hidden"
        color="none"
        glyph="gem-opal-wordmark-pride"
        height={Size.Icon * 0.421875}
        width={Size.Icon * 1.25}
      />
    )
  }
  let logoStyleOverrides = {}

  let logo: JSX.Element | null = null
  if (includeLogo) {
    logo = (
      <Icon
        ariaMode="hidden"
        color={Color[theme].Text.Default}
        glyph="gem-opal-logo"
        height={Size.Icon * 2.25}
        styleOverrides={styleOverrides}
        width={Size.Icon * 2.25}
      />
    )

    logoStyleOverrides = {
      container: {
        marginInlineStart: Spacing.S * 1.25,
      },
    }
  }

  return (
    <div css={styles.container}>
      {logo}

      <Icon
        ariaMode="hidden"
        color={Color[theme].Text.Default}
        glyph="gem-opal-wordmark"
        height={Size.Icon * 1.6875}
        styleOverrides={{ ...styleOverrides, ...logoStyleOverrides }}
        width={Size.Icon * 4.125}
      />
    </div>
  )
}
OpalWordmark.displayName = 'Beacon: OpalWordmark'
